const basePath = 'https://app.khuyana.von-ds.com';

export const environment = {
  production: true,
  consoleDebug: true,
  endpoints: {
    auth: `${basePath}/api`,
    admin: `${basePath}/api/admin`,
    common: `${basePath}/api/common`,
    commonParametrization: `${basePath}/api/common/parametrization`,
    commonStatic: `${basePath}/static`,
    history: `${basePath}/api/general`,
    general: `${basePath}/api/general`,
    odonto: `${basePath}/api/odonto`,
    report: `${basePath}/api/report`
  },
  company: {
    name: 'VON Development Studio'
  },
  modules: {
    odontology: true
  }
};
